'use client';

import { useSuspenseQuery } from '@tanstack/react-query';

import Container from '@/components/@base/container';
import Props from '@/components/app/archive/components/faq/type';
import { getArchiveInfoQueryOptions } from '@/components/app/archive/services/hooks';
import FAQ from '@/components/shared/components/faq';

import { DATA_CY_ARCHIVE_FAQ } from '@/constant/cypress';

export default function ArchiveFAQ({ slug, type }: Props) {
  const { data } = useSuspenseQuery(getArchiveInfoQueryOptions(slug, type));

  if (!(data && data.faq && data.faq.length > 0)) {
    return null;
  }

  return (
    <Container
      data-cy={DATA_CY_ARCHIVE_FAQ}
      className='mx-4 my-3 max-w-[1279px] rounded-lg p-3 shadow-[0px_10px_25px_0px_#969BA41A] md:mx-auto md:mt-24'
    >
      <FAQ faqList={data.faq} />
    </Container>
  );
}
